var map = {
	"./Chulo.png": 55,
	"./X.png": 56,
	"./black_and_decker.png": 57,
	"./black_and_decker22.png": 58,
	"./bostitch.png": 59,
	"./craftsman.png": 60,
	"./dewalt.png": 61,
	"./dewalt3.png": 62,
	"./irwin-en-or.png": 63,
	"./irwin-en.png": 64,
	"./irwin-pt.png": 65,
	"./irwin.png": 66,
	"./lenox.png": 67,
	"./porter_cable.png": 68,
	"./stanley-logo.png": 69,
	"./stanley.png": 27,
	"./stanley_b_d.png": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;